// The following bedbank properties have promotions but are excluded from the `spp_bedbank_promos`
// experiment because they comprise bundled rates (as part of the Dreamworld campaign) and _must_
// render in SPP.
export const FORCED_SPP_BEDBANK_OFFER_IDS = new Set([
  // Boardwalk Burleigh Beach
  // (accommodation service property ID: `973ff6a7-838e-469a-a6ec-c55d0bc7d7d8`)
  '724b696c-ee7d-4a0a-8c30-9815ac086dd0',
  // Broadbeach Holiday Apartments, Store 19
  // (accommodation service property ID: `618133ec-d321-45a9-895e-6adf9000c880`)
  '6b619c1a-df3b-4d3c-9733-74674d805d2e',
  // Dorsett Gold Coast
  // (accommodation service property ID: `8466bf1a-e508-435b-9d85-e0641993bf6e`)
  'dde7af04-ba54-4da4-9950-51655ad25b4f',
  // Hilton Surfers Paradise Hotel & Residences
  // (accommodation service property ID: `ad550432-adb0-4854-9411-92605a98538b`)
  '23ef2ddf-d81b-42fd-ba13-73750fb343f5',
  // Kirra Surf Apartments
  // (accommodation service property ID: `44c76c81-34b9-4b71-b81b-7012a75bdba3`)
  '471907fd-ef2f-43df-82fb-cbd53aeda3e1',
  // The Langham Gold Coast
  // (accommodation service property ID: `98216fa9-fca2-4d90-91b6-5441075978e2`)
  'be5a1021-ce83-42d9-a413-b29637f49428',
  // Mantra Coolangatta Beach
  // (accommodation service property ID: `09a23c25-e467-457b-b6b6-9604f9bf2a21`)
  '1c392360-47e3-414c-ac9f-b58f86d4df72',
  // Novotel Surfers Paradise
  // (accommodation service property ID: `9258fe33-e363-4bde-ac7a-6c3ea2064afb`)
  '7a238d46-da04-4571-83e3-fd8cb28cebf4',
  // The Point Coolum Beach
  // (accommodation service property ID: `d01aa98e-3f45-41c0-9986-5da330607606`)
  'b331abb4-8538-49cc-9156-536761bd3e03',
  // Qube Broadbeach
  // (accommodation service property ID: `1e9e6c97-5242-44fb-8f37-c1d027cedbaf`)
  '6d85de8b-3fd4-4c00-b082-e4072fe7d087',
  // Sheraton Grand Mirage Resort, Gold Coast
  // (accommodation service property ID: `05a93eda-7492-4539-83b1-1e5eab0f155c`)
  '14bae874-5812-46ba-9884-9602b6b8e264',
  // Southern Cross Beachfront Holiday Apartments
  // (accommodation service property ID: `9d279cd0-8331-4c3f-b1b0-70644631482b`)
  '9c3d6e0f-a035-4521-ad47-abc9f5758b36',
  // Talisman Beachside
  // (accommodation service property ID: `494757d8-1b90-4533-b894-07973f4b0bd3`)
  '5e69b01c-05e1-49bb-966b-ce6e8fdd72ad',
  // Turtle Beach Resort
  // (accommodation service property ID: `acfcd869-5dfe-4429-b0d6-a215b4c369e3`)
  '7185e8bd-40d9-4b39-9ac2-a9623ff7ef15',
  // ULTIQA Beach Haven on Broadbeach
  // (accommodation service property ID: `75d6911b-18df-43a8-ad47-5b24e799ac69`)
  '530630cb-a192-4ae9-a163-404292171605',
  // Ultra Broadbeach
  // (accommodation service property ID: `a4102d06-9e22-485f-a59d-5e6160a9023e`)
  'bf1e51da-e175-45fb-b270-13f4a095ed8e',
  // The Wave Resort
  // (accommodation service property ID: `5f1d4814-3dcb-452e-8b4a-6c631d09fd67`)
  '929b7f4e-d23c-4859-b3ab-dc40d9bf084d',
])
